<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{'title.procedure_management_enteprise' | translate}}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion>
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ "title.search_info" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm" [formGroup]="searchProcedureForm" class="pb-3" (ngSubmit)="onClickBtnFilter()"
          (keydown.enter)="onClickBtnFilter()">
          <div class="row">
            <div class="col-4">
              <!-- ten quy trình-->
              <mat-form-field class="w-100">
                <input (focusout)="
                        focusOut('name')
                      " #focusInput matInput type="text" [placeholder]="'placeholder.procedure_name' | translate"
                      name="procedureName" maxlength="200" autocomplete="off" formControlName="nameContains"
                      (keydown.enter)="$event.preventDefault()" />
                <button mat-button *ngIf="searchProcedureForm?.controls?.nameContains?.value" type="button"
                  matSuffix mat-icon-button aria-label="Clear" (click)="clearData('nameContains')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-4">
              <!-- loai quy trình -->
              <mat-form-field class="w-100">
                <mat-select id="type" name="type" placeholder="{{'placeholder.procedure_type' | translate}}" formControlName="typeContains" [value]="'1'">
                  <mat-option value="null">
                    {{ "system_document_template.cbx_document_status.cbx_document_status_select_all" | translate }}
                  </mat-option>
                  <mat-option value="1">
                    {{ "title.procedure_full" | translate }}
                  </mat-option>

                  <mat-option value="2">
                    {{ "title.procedure_internal" | translate }}
                  </mat-option>
                </mat-select>
                <!-- <button mat-button *ngIf="searchProcedureForm?.controls?.typeContains?.value" type="button" matSuffix
                  mat-icon-button aria-label="Clear" (click)="clearData('typeContains')">
                  <mat-icon>close</mat-icon>
                </button> -->
              </mat-form-field>
            </div>
            <div class="col-4">
              <!-- trang thai -->
              <mat-form-field class="w-100">
                <mat-select id="status" name="status" [placeholder]="'document_template.lbl_status' | translate"
                  formControlName="statusEquals">
                  <mat-option value="null">
                    {{
                    "system_document_template.cbx_document_status.cbx_document_status_select_all"
                    | translate
                    }}
                  </mat-option>
                  <mat-option value="ACTIVE">
                    {{
                    "system_document_template.cbx_document_status.cbx_document_status_active"
                    | translate
                    }}
                  </mat-option>
                  <mat-option value="INACTIVE">
                    {{
                    "system_document_template.cbx_document_status.cbx_document_status_inactive"
                    | translate
                    }}
                  </mat-option>
                </mat-select>
                <!-- <button mat-button type="button" *ngIf="searchProcedureForm?.controls?.statusEquals?.value" matSuffix mat-icon-button aria-label="Clear"
                  (click)="clearData('statusEquals')">
                  <mat-icon>close</mat-icon>
                </button> -->
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <button mat-stroked-button color="primary" type="submit">
                <mat-icon class="mr-0" style="font-weight: 900">search</mat-icon>
                {{ "search_form.search" | translate }}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">

        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
          <span>{{ "procedure.list_procedure" | translate }} ({{
            paginate.totalRow
            }})</span>
          <button class="pull-right" mat-stroked-button color="primary" type="button"
                  (click)="openAddDialog()"
                  *ngIf="(!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM)) &&
                           (userType == 1 || (userType == 2 && permissions.includes(1)))"
                  [disabled]="commonService.getIsLockedEnterprise()">
            <mat-icon class="mr-0">add_circle</mat-icon>{{ "button.create_procedure" | translate }}
          </button>
        </mat-panel-title>

        <div>
          <mat-table
          [dataSource]="procedureDataSource"
          matSort>

            <!-- số thứ tự Column -->
            <ng-container matColumnDef="stt">
              <mat-header-cell
                *matHeaderCellDef
                class="mat-cell-non-boder-right-bottom"
                >{{ "headertable.stt" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                class="mat-cell-non-boder-right-bottom"
              >
                {{ paginate.currentPage * paginate.pageSize + i + 1 }}
              </mat-cell>
            </ng-container>

            <!-- Tên quy trình Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell
                *matHeaderCellDef
                class="mat-cell-non-boder-right-bottom"
                >{{ "headertable.procedure_name" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element, let i=index"
                [matTooltip]="displayTooltip(element.procedureName, i, 'nameDoc')"
                class="mat-cell-non-boder-right-bottom cell"
              >
                <span class="fix-width fw-100 nameDoc">{{ element.procedureName }}</span>
              </mat-cell>
            </ng-container>

            <!-- mô tả Column -->
            <ng-container matColumnDef="description">
              <mat-header-cell
                *matHeaderCellDef
                class="mat-cell-non-boder-right-bottom"
                >{{ "form.description" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element, let i=index"
                [matTooltip]="displayTooltip(element.description, i, 'codeDoc')"
                class="mat-cell-non-boder-right-bottom"
              >
                <span class="fix-width fw-100 codeDoc">{{ element.description }}</span>
              </mat-cell>
            </ng-container>

            <!-- loại quy trình Column -->
            <ng-container matColumnDef="type">
              <mat-header-cell
                *matHeaderCellDef
                >{{ "placeholder.procedure_type" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
              >
              <span *ngIf="element.type == 1" class="fix-width fw-100 codeDoc">{{ "title.procedure_full" | translate }}</span>
              <span *ngIf="element.type == 2" class="fix-width fw-100 codeDoc">{{ "title.procedure_internal" | translate }}</span>
              </mat-cell>
            </ng-container>

            <!-- Trạng thái Column -->
            <ng-container matColumnDef="status">
              <mat-header-cell
                *matHeaderCellDef
                class="text-center mat-cell-non-boder-right-bottom"
              >
                {{ "headertable.status" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom"

              >
                <button
                  mat-icon-button
                  type="button"
                  (click)="changeStatus(element)"
                  *ngIf="(userType == 1 || (userType == 2 && permissions.includes(1)))"
                  [disabled]="commonService.getIsLockedEnterprise()"
                >
                  <mat-icon *ngIf="element.status == 0"
                    matTooltip="{{'procedure.tooltips.icon_change_to_active' | translate}}">lock</mat-icon>
                  <mat-icon *ngIf="element.status == 1"
                    matTooltip="{{'procedure.tooltips.icon_change_to_inactive' | translate}}">lock_open</mat-icon>
                </button>

                <button
                  mat-icon-button
                  *ngIf="!(userType == 1 || (userType == 2 && permissions.includes(1)))"
                  [disabled]="commonService.getIsLockedEnterprise()"
                >
                  <mat-icon *ngIf="element.status == 0" style="cursor: default;"
                    matTooltip="{{'procedure.tooltips.icon_status_inactive' | translate}}">lock</mat-icon
                  >
                  <mat-icon *ngIf="element.status == 1" style="cursor: default;"
                    matTooltip="{{'procedure.tooltips.icon_status_active' | translate}}">lock_open</mat-icon
                  >
                </button>

                <mat-icon
                  style="color: grey; width: auto"
                  *ngIf="element.isDraft"
                >
                  border_color</mat-icon
                >
              </mat-cell>
            </ng-container>

            <!-- Tác động Column -->
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="text-center">
                {{ "headertable.action_header" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="text-center">
                <button
                  mat-icon-button
                  type="button"
                  (click)="openViewDialog(element)"
                  [disabled]="element.isDraft"
                >
                  <mat-icon
                    matTooltip="{{'title.detail' | translate}}">visibility</mat-icon
                  >
                </button>
                <!-- <button
                  mat-icon-button
                  type="button"
                  *ngIf="element.isDraft"
                  style="opacity: 0; cursor: default"
                >
                  <mat-icon>visibility</mat-icon>
                </button> -->
                <button
                  mat-icon-button
                  type="button"
                  *ngIf="(!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM)) && (userType == 1 || (userType == 2 && permissions.includes(1)))"
                  (click)="openEditDialog(element)"
                  [disabled]="commonService.getIsLockedEnterprise()"
                >
                  <mat-icon
                    matTooltip="{{
                      'document_template.tooltip_edit' | translate
                    }}"
                    >mode_edit</mat-icon
                  >
                </button>
                <button mat-icon-button
                      type="button"
                      (click)="openAddDialog(element)"
                      *ngIf="(!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM)) && (userType == 1 || (userType == 2 && permissions.includes(1)))"
                      [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon
                    type="button"
                    matTooltip="{{
                      'enterprise_contract.buttons.copy' | translate
                    }}"
                    >file_copy</mat-icon
                  >
                </button>
                <button
                  mat-icon-button
                  type="button"
                  (click)="deleteProcedure(element)"
                  *ngIf="(!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM)) && (userType == 1 || (userType == 2 && permissions.includes(1)))"
                  [disabled]="commonService.getIsLockedEnterprise()">
                  <i
                    [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                    class="fa fa-trash"
                    style="font-size: 20px"
                    aria-hidden="true"
                    matTooltip="{{
                      'document_template.tooltip_delete' | translate
                    }}"
                  ></i>
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="element-row"
            >
            </mat-row>

          </mat-table>

           <!-- Pagination -->
           <app-pagination
           [(paginate)]="paginate"
           (pageChange)="onPageChange($event.page, $event.pageSize)"
         >
         </app-pagination>
        </div>

      </mat-expansion-panel>
    </mat-accordion>

  </mat-card-content>
</mat-card>
